import { render, staticRenderFns } from "./frontend.vue?vue&type=template&id=58237fa4&"
import script from "./frontend.vue?vue&type=script&lang=js&"
export * from "./frontend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports